import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NgxsModule } from '@ngxs/store';

import { NewsState } from './store/states/news.state';

@NgModule({
  imports: [CommonModule, NgxsModule.forFeature([NewsState])],
})
export class NewsDataAccessModule {}
